export const vigilant = {
    firstName: '',
    lastName: '',
    email: '',
    oldEmail: '',
    username: '',
    oldUsername: '',
    primaryPhone: '',
    photoURL: '',
    account: '',
    client: '',
    site: '',
    customerUser: {
        status: 'ACTIVE',
        subtype: '',
    },
    address: {
        cep: '',
        address: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        ibge: '',
        gia: '',
    },
    type: 'USER-CUSTOMER',
    status: 'ACTIVE',
}
